"use strict";

/**
 * Флаг: на странице входа требуется капча.
 * @type {boolean}
 */
window.loginCaptchaRequired = false;

/**
 * Флаг: капча успешно пройдена на клиенте (UX).
 * Безопасность обеспечивается серверной проверкой токена в Login POST.
 * @type {boolean}
 */
window.loginCaptchaPassed = false;

/**
 * Обработка ответа reCaptcha (токен одноразовый — верификация только на сервере при входе).
 * @param {string} response
 */
function checkCaptchaResponse(response) {
  var submitButton = document.getElementById("submitLoginId");
  var captchaTokenInput = document.getElementById("CaptchaToken");
  var warning = document.getElementById("captchaEmptyWarning");
  if (response) {
    window.loginCaptchaPassed = true;
    if (captchaTokenInput) captchaTokenInput.value = response;
    if (submitButton) submitButton.disabled = false;
    if (warning) warning.hidden = true;
  } else {
    onCaptchaExpired();
  }
}

/** Капча истекла или не пройдена — блокируем вход только если капча обязательна */
function onCaptchaExpired() {
  window.loginCaptchaPassed = false;
  if (window.loginCaptchaRequired !== true) return;
  var submitButton = document.getElementById("submitLoginId");
  var captchaTokenInput = document.getElementById("CaptchaToken");
  if (submitButton) submitButton.disabled = true;
  if (captchaTokenInput) captchaTokenInput.value = "";
}

/** Колбэк загрузки капчи, если она не нужна */
function onCaptchaEmptyCallback() {
  console.log("captcha is hidden");
}